const autoNgTemplateLoaderTemplate1 = require('./ldap-user-search-item.html');

import controller from './ldap-user-search-item.controller';

export const ldapUserSearchItem = {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller,
  bindings: {
    config: '=',
    index: '<',
    showUsernameFormat: '<',
    domainSuffix: '@',
    baseFilter: '@',
    onRemoveClick: '<',
    limitedFeatureId: '<',
  },
};
